import React from 'react';
import styled from 'styled-components';

const CardsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`

const CardsGrid = ({ children }) => {
    return (
        <CardsContainer>
          {children}
        </CardsContainer>
    )
}

export default CardsGrid;